// import { setUser } from "@/features/auth/UserSlice";
// import { RootState } from "@/store";
import React, { useMemo } from "react";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
import AuthErrorPage from "./auth-error-page";
import { useSidebar } from "@/components/ui/sidebar";
import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { RootState } from "@/store";

interface ProtectedRouteProps {
  // isAuthenticated: boolean;
  children: JSX.Element;
  forceOverlay?: boolean
}

const SelectivelyProtectedRoute: React.FC<ProtectedRouteProps> = ({
  // isAuthenticated,
  children,
  forceOverlay = false
}) => {
  // const user = useSelector(
  //   (root: RootState) => root.rootReducer.userReducer.user
  // );

  // const dispatch = useDispatch<AppDispatch>();
  const { open } = useSidebar();

  const isAuth = useMemo(() => {
    const user = JSON.parse(localStorage.getItem("user") + "");
    return user ;
  }, []);

  // useEffect(() => {
  //   if (isAuth) {
  //     cookies.set("isAuthenticated", "true", {
  //       expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
  //     });
  //   } else {
  //     cookies.set("isAuthenticated", "false");
  //   }
  // }, [isAuth]);

  // useEffect(() => {
  //   console.log("user details protectedRoute", user);

  //   if (user && user.subscription_details?.status == "active") {
  //     console.log(
  //       "user details protectedRoute",
  //       user.subscription_details?.status
  //     );
  //     setIsAuthenticated(true);
  //   } else {
  //     setIsAuthenticated(false);
  //   }
  // }, [user]);
//     const user = useSelector(
//     (state: RootState) => state.rootReducer.userReducer.user
//   );
// console.log(user,"line 67")
//  const skipQuestions = useSelector(
//   (state: RootState) => state.rootReducer.userReducer.skipQuestions
// );

// console.log(skipQuestions, "line 68");

//    if(user?.questionnaireFilled=== false  && skipQuestions === false) {
//     //if the user is not authenticated(not logged In), redirect to the home page
//     return <Navigate to="/chat/newOnboarding" replace />;
//   }

  if(!isAuth) {
    //if the user is not authenticated(not logged In), redirect to the home page
    return <Navigate to="/" replace />;
  }

  if ( forceOverlay ) {
    // If the user does not have access to the particular route/module, show the AuthErrorPage overlay on top of the children
    return (
      <div className="relative">
        {/* Render the auth error overlay */}
        <div
          className={`fixed top-13 z-50 bg-[#000000]/60 ${open ? "w-[90vw]" : "w-[98vw]"}`}
        >
          <AuthErrorPage />
        </div>
        {/* Render the protected content in the background */}
        <div className="pointer-events-none">{children}</div>
      </div>
    );
  }

  // If the user is authenticated, render the children (the protected page)
  return children;
};

export default SelectivelyProtectedRoute;
